import { render, staticRenderFns } from "./replacePhone.vue?vue&type=template&id=5ecde98f&scoped=true&"
import script from "./replacePhone.vue?vue&type=script&lang=js&"
export * from "./replacePhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecde98f",
  null
  
)

export default component.exports